module.exports = __webpack_public_path__ + "Pledge_10.31dee8fc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/landing/Pledge_10.png
// module id = bgFh
// module chunks = 0